import { useUIStore } from '@/state/useUIStore';
import './Settings.css';

export function Settings() {
  const { closeSettings, showSettings, settings, updateSettings } = useUIStore();

  if (!showSettings) return null;

  return (
    <div className="settings-overlay" onClick={closeSettings}>
      <div className="settings-modal" onClick={(e) => e.stopPropagation()}>
        <header className="settings-header">
          <h2>SETTINGS</h2>
          <button className="close-btn" onClick={closeSettings}>&times;</button>
        </header>

        <div className="settings-content">
          {/* Audio Section */}
          <section className="settings-section">
            <h3 className="section-title">Audio</h3>

            <div className="setting-row">
              <label>Master Volume</label>
              <div className="slider-container">
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={settings.masterVolume * 100}
                  onChange={(e) => updateSettings({ masterVolume: Number(e.target.value) / 100 })}
                />
                <span className="slider-value">{Math.round(settings.masterVolume * 100)}%</span>
              </div>
            </div>

            <div className="setting-row">
              <label>Sound Effects</label>
              <div className="slider-container">
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={settings.sfxVolume * 100}
                  onChange={(e) => updateSettings({ sfxVolume: Number(e.target.value) / 100 })}
                />
                <span className="slider-value">{Math.round(settings.sfxVolume * 100)}%</span>
              </div>
            </div>

            <div className="setting-row">
              <label>Music</label>
              <div className="slider-container">
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={settings.musicVolume * 100}
                  onChange={(e) => updateSettings({ musicVolume: Number(e.target.value) / 100 })}
                />
                <span className="slider-value">{Math.round(settings.musicVolume * 100)}%</span>
              </div>
            </div>
          </section>

          {/* Graphics Section */}
          <section className="settings-section">
            <h3 className="section-title">Graphics</h3>

            <div className="setting-row">
              <label>Quality</label>
              <div className="button-group">
                {(['low', 'medium', 'high'] as const).map((quality) => (
                  <button
                    key={quality}
                    className={`quality-btn ${settings.graphicsQuality === quality ? 'active' : ''}`}
                    onClick={() => updateSettings({ graphicsQuality: quality })}
                  >
                    {quality.charAt(0).toUpperCase() + quality.slice(1)}
                  </button>
                ))}
              </div>
            </div>

            <div className="setting-row">
              <label>Dynamic Resolution</label>
              <button
                className={`toggle-btn ${settings.dynamicResolution ? 'active' : ''}`}
                onClick={() => updateSettings({ dynamicResolution: !settings.dynamicResolution })}
              >
                {settings.dynamicResolution ? 'ON' : 'OFF'}
              </button>
            </div>

            <div className="setting-row">
              <label>Show FPS</label>
              <button
                className={`toggle-btn ${settings.showFps ? 'active' : ''}`}
                onClick={() => updateSettings({ showFps: !settings.showFps })}
              >
                {settings.showFps ? 'ON' : 'OFF'}
              </button>
            </div>
          </section>

          {/* Controls Section */}
          <section className="settings-section">
            <h3 className="section-title">Controls</h3>

            <div className="controls-info">
              <div className="control-row">
                <span className="key">W / &#8593;</span>
                <span className="action">March Forward</span>
              </div>
              <div className="control-row">
                <span className="key">S / &#8595;</span>
                <span className="action">Retreat</span>
              </div>
              <div className="control-row">
                <span className="key">A / &#8592;</span>
                <span className="action">Flank Left</span>
              </div>
              <div className="control-row">
                <span className="key">D / &#8594;</span>
                <span className="action">Flank Right</span>
              </div>
              <div className="control-row">
                <span className="key">Mouse</span>
                <span className="action">Aim Direction</span>
              </div>
              <div className="control-row">
                <span className="key">Left Click</span>
                <span className="action">Strike</span>
              </div>
              <div className="control-row">
                <span className="key">ESC</span>
                <span className="action">Menu / Settings</span>
              </div>
            </div>
          </section>
        </div>

        <footer className="settings-footer">
          <button className="done-btn" onClick={closeSettings}>
            Done
          </button>
        </footer>
      </div>
    </div>
  );
}
